import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=b9b4d65e&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=b9b4d65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b4d65e",
  null
  
)

export default component.exports